import consumer from "./consumer";

document.addEventListener("DOMContentLoaded", () => {
    const currentUser = $("#current_user_id").val();


    function createDownloadModal() {
        const existing = document.getElementById("downloadProgressModal");
        if (existing) existing.remove();

        const modalEl = document.createElement("div");
        modalEl.id = "downloadProgressModal";
        modalEl.style.display = "none";
        modalEl.style.position = "fixed";
        modalEl.style.top = "50%";
        modalEl.style.left = "50%";
        modalEl.style.transform = "translate(-50%, -50%)";
        modalEl.style.zIndex = "1050";
        modalEl.style.backgroundColor = "#fff";
        modalEl.style.padding = "25px 30px";
        modalEl.style.borderRadius = "16px";
        modalEl.style.width = "420px";
        modalEl.style.boxShadow = "0 15px 35px rgba(0,0,0,0.15)";
        modalEl.style.transition = "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)";

        modalEl.innerHTML = `
        <div class="modal-header" style="justify-content:center; border-bottom:none; padding: 0 0 15px 0;">
            <h5 class="font-weight-bold" style="color: #1a1a2e; margin: 0; font-size: 20px;">Download Progress</h5>
        </div>
        <div class="modal-body" style="padding: 0; text-align: center;">
            <div id="downloadStatusIcon" style="font-size: 44px; color: #ff5e14; margin-bottom: 15px;">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
            <p id="downloadStatusText" style="font-size: 15px; font-weight: 500; color: #1a1a2e; margin-bottom: 12px;">Starting...</p>
            <div style="height: 10px; background:#f0f2f5; border-radius:10px; overflow: hidden; margin-bottom: 12px; position: relative;">
                <div id="downloadProgressBar" style="height:100%; width:0%; background: linear-gradient(45deg, #ff5e14, #ff8c52); border-radius:10px; transition: width 0.3s ease;"></div>
            </div>
            <div id="downloadPercentageText" style="font-size: 14px; font-weight: bold; color: #ff5e14; margin-bottom: 8px;">0%</div>
            <small id="downloadDetails" style="display:none; color: #6c757d; font-size: 12px; margin-top:5px; margin-bottom: 10px; word-break: break-all;"></small>
        </div>
        <div id="downloadModalFooter" style="display:none; margin-top:20px; display:flex; justify-content:center; gap:12px; align-items:center;">
            <a id="downloadFileLink" style="display:none; text-decoration:none; padding:10px 20px; background:#ff5e14; color:white; border-radius:8px; font-weight: 600; font-size: 14px; box-shadow: 0 4px 10px rgba(255, 94, 20, 0.2); transition: background-color 0.2s;">Download ZIP</a>
            <button id="footerCloseBtn" style="padding:10px 20px; border:1px solid #ced4da; background:#fff; color:#495057; border-radius:8px; font-weight: 600; font-size: 14px; cursor:pointer; transition: background-color 0.2s;">Close</button>
        </div>
    `;

        document.body.appendChild(modalEl);

        const closeBtn = modalEl.querySelector("#footerCloseBtn");
        closeBtn.addEventListener("click", () => hideModal(modalEl));
        closeBtn.addEventListener("mouseover", () => closeBtn.style.backgroundColor = "#f8f9fa");
        closeBtn.addEventListener("mouseout", () => closeBtn.style.backgroundColor = "#fff");

        const linkBtn = modalEl.querySelector("#downloadFileLink");
        linkBtn.addEventListener("mouseover", () => linkBtn.style.backgroundColor = "#e05312");
        linkBtn.addEventListener("mouseout", () => linkBtn.style.backgroundColor = "#ff5e14");
        linkBtn.addEventListener("click", () => {
            setTimeout(() => hideModal(modalEl), 300);
        });

        return modalEl;
    }

    function showModal(modalEl) {
        if (!modalEl) modalEl = createDownloadModal();
        modalEl.style.display = "block";
        document.body.classList.add("modal-open");

        if (!document.querySelector(".modal-backdrop")) {
            const backdrop = document.createElement("div");
            backdrop.className = "modal-backdrop";
            backdrop.style.position = "fixed";
            backdrop.style.top = 0;
            backdrop.style.left = 0;
            backdrop.style.width = "100%";
            backdrop.style.height = "100%";
            backdrop.style.background = "rgba(0,0,0,0.5)";
            backdrop.style.zIndex = "1040";

            backdrop.addEventListener("click", () => shakeModal(modalEl));

            document.body.appendChild(backdrop);
        }
    }


    function hideModal(modalEl) {
        if (!modalEl) modalEl = document.getElementById("downloadProgressModal");
        if (!modalEl) return;
        modalEl.style.display = "none";
        document.body.classList.remove("modal-open");
        document.querySelectorAll(".modal-backdrop").forEach(b => b.remove());
        resetDownloadModal();
    }

    function shakeModal(modalEl) {
        modalEl.style.transform = "translate(-50%, -50%) translateX(-10px)";
        setTimeout(() => modalEl.style.transform = "translate(-50%, -50%) translateX(10px)", 100);
        setTimeout(() => modalEl.style.transform = "translate(-50%, -50%)", 200);
    }

    function resetDownloadModal() {
        const progressBar = document.getElementById("downloadProgressBar");
        const statusText = document.getElementById("downloadStatusText");
        const details = document.getElementById("downloadDetails");
        const footer = document.getElementById("downloadModalFooter");
        const fileLink = document.getElementById("downloadFileLink");
        const statusIcon = document.getElementById("downloadStatusIcon");
        const percentageText = document.getElementById("downloadPercentageText");

        if (!progressBar || !statusText || !details || !footer || !fileLink) return;

        statusText.textContent = "Starting...";
        progressBar.style.width = "0%";
        progressBar.style.background = "linear-gradient(45deg, #ff5e14, #ff8c52)";
        if (percentageText) {
            percentageText.textContent = "0%";
            percentageText.style.color = "#ff5e14";
        }
        if (statusIcon) {
            statusIcon.innerHTML = '<i class="fas fa-spinner fa-spin" style="color: #ff5e14;"></i>';
            statusIcon.style.display = 'block';
        }
        details.style.display = "none";
        footer.style.display = "none";
        fileLink.style.display = "none";
    }

    function updateDownloadProgress(message) {
        const statusText = document.getElementById("downloadStatusText");
        const progressBar = document.getElementById("downloadProgressBar");
        const details = document.getElementById("downloadDetails");
        const fileLink = document.getElementById("downloadFileLink");
        const footer = document.getElementById("downloadModalFooter");
        const statusIcon = document.getElementById("downloadStatusIcon");
        const percentageText = document.getElementById("downloadPercentageText");

        if (!statusText || !progressBar) return;

        switch (message.status) {
            case "queued":
                statusText.textContent = "Queuing download job...";
                if (statusIcon) {
                    statusIcon.innerHTML = '<i class="fas fa-spinner fa-spin" style="color: #ff5e14;"></i>';
                    statusIcon.style.display = 'block';
                }
                progressBar.style.width = "0%";
                progressBar.style.background = "linear-gradient(45deg, #ff5e14, #ff8c52)";
                if (percentageText) {
                    percentageText.textContent = "0%";
                    percentageText.style.color = "#ff5e14";
                }
                break;
            case "starting":
                statusText.textContent = "Preparing files...";
                if (statusIcon) {
                    statusIcon.innerHTML = '<i class="fas fa-spinner fa-spin" style="color: #ff5e14;"></i>';
                    statusIcon.style.display = 'block';
                }
                break;
            case "processing":
                const progress = message.progress || 0;
                statusText.textContent = `Processing files... (${message.processed_files || 0}/${message.total_files || 0})`;
                progressBar.style.width = progress + "%";
                progressBar.style.background = "linear-gradient(45deg, #ff5e14, #ff8c52)";
                if (percentageText) {
                    percentageText.textContent = Math.round(progress) + "%";
                    percentageText.style.color = "#ff5e14";
                }
                if (message.current_file) {
                    details.style.display = "block";
                    details.textContent = `Current: ${message.current_file}`;
                }
                break;
            case "completed":
                statusText.textContent = "Download ready!";
                if (statusIcon) {
                    statusIcon.innerHTML = '<i class="fas fa-check-circle" style="color: #28a745;"></i>';
                    statusIcon.style.display = 'block';
                }
                progressBar.style.width = "100%";
                progressBar.style.background = "#28a745";
                if (percentageText) {
                    percentageText.textContent = "100%";
                    percentageText.style.color = "#28a745";
                }
                if (message.download_url) {
                    fileLink.href = message.download_url;
                    fileLink.style.display = "inline-block";
                }
                if (message.file_count) {
                    details.style.display = "block";
                    details.textContent = `${message.file_count} files processed`;
                }
                footer.style.display = "flex";
                break;
            case "failed":
                statusText.textContent = "Download failed";
                if (statusIcon) {
                    statusIcon.innerHTML = '<i class="fas fa-times-circle" style="color: #dc3545;"></i>';
                    statusIcon.style.display = 'block';
                }
                progressBar.style.width = "100%";
                progressBar.style.background = "#dc3545";
                if (percentageText) {
                    percentageText.textContent = "Failed";
                    percentageText.style.color = "#dc3545";
                }
                details.style.display = "block";
                details.textContent = message.error || "Unknown error occurred";
                footer.style.display = "flex";
                break;
        }
    }


    consumer.subscriptions.create(
        {channel: "DrawingDownloadChannel", user_id: currentUser},
        {
            connected() {
            },
            disconnected() {
            },
            received(data) {
                showModal(document.getElementById("downloadProgressModal"));
                updateDownloadProgress(data.message || data);
            }
        }
    );

    $(document).on("click", ".project-drawings-links-btn", function (e) {
        e.preventDefault();
        const contractId = $(this).data("contract-id");
        const btn = $(this);
        const originalText = btn.html();

        resetDownloadModal();
        showModal(document.getElementById("downloadProgressModal"));

        btn.prop("disabled", true).html('<i class="fas fa-spinner fa-spin"></i> Starting...');

        $.ajax({
            type: "GET",
            url: `/download_drawings_zip/${contractId}`,
            headers: {"X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")},
            dataType: "json",
            success: res => {},
            error: xhr => {
                console.error("❌ Failed:", xhr.responseText);
                alert("Failed to start download job.");
            },
            complete: () => btn.prop("disabled", false).html(originalText),
        });
    });
});
